import {specialities} from "../Constants/specialities";
import {setPetType} from "./petInfo";

export const getPetSpecialtyValue = (pet: { type: string; breed?: string }): string => {
    const petType = pet.type === "Other" ? pet.breed : pet.type;
    const fromSpecialities = specialities.find(
        (s) => s.value === petType || s.label === petType
    );
    if (fromSpecialities) {
        return fromSpecialities.value;
    }
    const mapped = setPetType(pet.type);
    if (mapped !== "Other") {
        return mapped;
    }
    return petType || "";
};

export const petMatchesGuestType = (
    pet: { type: string; breed?: string },
    guestPetType: string
): boolean => getPetSpecialtyValue(pet) === guestPetType;
